export class Subscription {
  id = null;
  endDate = null;
  numberOfSeats = null;
  state = null;
  paymentState = null;
  subscriptionType = null;

  constructor(dbSubscription) {
    if (dbSubscription) {
      this.id = dbSubscription.id;
      this.endDate = new Date(dbSubscription.endDate);
      this.state = dbSubscription.state;
      this.paymentState = dbSubscription.paymentState;
      this.subscriptionType = dbSubscription.subscriptionType;
    }
  }

  get isExpiring() {
    const expiringDate = new Date(this.endDate);
    expiringDate.setDate(this.endDate.getDate() - 10);

    if (expiringDate < new Date()) {
      return true;
    }
    return false;
  }

  get isExpired() {
    if (this.endDate < new Date()) {
      return true;
    }
    return false;
  }

  get isPaymentRejected() {
    if (this.paymentState === SUBSCRIPTION_PAYMENT_STATE.REJECTED) {
      return true;
    }
    return false;
  }
}

export const SUBSCRIPTION_TYPE = Object.freeze({
  NONE: 0,
  TRYOUT: 1,
  FREE: 2,
  PRO: 4
});

export const SUBSCRIPTION_STATE = Object.freeze({
  OK: 0,
  READONLY: 1,
  EXPIRED: 2,
  AWAITING_PAYMENT: 4,
  CANCELLED: 8,
  PAYMENT_FAILED: 16
});

export const SUBSCRIPTION_PAYMENT_STATE = Object.freeze({
  NOVALUE: 0,
  INITIAL: 1,
  PENDING: 2,
  REJECTED: 3,
  PROCESSED: 4,
  CANCELLED: 5,
  ACTIVE: 6
});
